import React from "react";

export function PaginationSkeleton() {
  return (
    <div className="flex justify-between items-center mt-4 animate-pulse">
      <div className="flex gap-2">
        <div className="h-8 w-24 bg-gray-200 rounded"></div>
        <div className="h-8 w-24 bg-gray-200 rounded"></div>
      </div>
      <div className="h-8 w-32 bg-gray-200 rounded"></div>
    </div>
  );
}

function LoadingSkeleton() {
  return (
    <div className="bg-white rounded-lg p-4 md:p-6 mb-4 shadow-none border-gray-200 border animate-pulse">
      <div className="flex flex-col md:flex-row md:items-center space-y-4 md:space-y-0">
        {/* Airline Info */}
        <div className="flex items-center justify-between md:justify-start md:w-auto">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-gray-200 rounded-lg"></div>
            <div className="h-4 w-24 bg-gray-200 rounded"></div>
          </div>
          {/* Mobile Price */}
          <div className="md:hidden">
            <div className="h-6 w-16 bg-gray-200 rounded"></div>
          </div>
        </div>

        {/* Flight Details */}
        <div className="flex-grow md:px-8">
          <div className="flex flex-col space-y-4">
            <div className="flex items-center justify-between">
              {/* Departure */}
              <div className="text-center">
                <div className="h-4 w-20 bg-gray-200 rounded mb-2"></div>
                <div className="h-6 w-16 bg-gray-200 rounded mb-2"></div>
                <div className="h-4 w-12 bg-gray-200 rounded"></div>
              </div>

              {/* Flight Duration */}
              <div className="flex flex-col items-center flex-grow px-4">
                <div className="h-4 w-16 bg-gray-200 rounded mb-2"></div>
                <div className="relative w-full">
                  <div className="border-t border-gray-200 w-full absolute top-1/2"></div>
                </div>
                <div className="h-4 w-16 bg-gray-200 rounded mt-2"></div>
              </div>

              {/* Arrival */}
              <div className="text-center">
                <div className="h-4 w-20 bg-gray-200 rounded mb-2"></div>
                <div className="h-6 w-16 bg-gray-200 rounded mb-2"></div>
                <div className="h-4 w-12 bg-gray-200 rounded"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Price and Buttons - Desktop */}
        <div className="hidden md:flex md:flex-col md:items-end space-y-2">
          <div className="h-8 w-24 bg-gray-200 rounded"></div>
          <div className="h-8 w-20 bg-gray-200 rounded"></div>
          <div className="h-8 w-24 bg-gray-200 rounded"></div>
        </div>

        {/* Mobile Buttons */}
        <div className="flex md:hidden justify-between items-center space-x-2 pt-4 border-t border-gray-100">
          <div className="h-8 w-full bg-gray-200 rounded"></div>
          <div className="h-8 w-full bg-gray-200 rounded"></div>
        </div>
      </div>
    </div>
  );
}

export default LoadingSkeleton;
